import { Link } from "react-router-dom";
import { ArrowUpRight, Bell } from "lucide-react";
import { fmtPrice } from "@/lib/api";
import { NotifyModal } from "@/components/site/NotifyModal";

export function ProductCard({ product, index }) {
  const live = product.status === "live";
  const num = String(index + 1).padStart(2, "0");

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group relative flex h-full flex-col border border-white/10 bg-[#121418] p-6 transition-colors duration-300 hover:border-[#FF5500]/50 md:p-7"
    >
      <div className="flex items-start justify-between">
        <span className="font-mono-ind text-xs tracking-[0.2em] text-slate-500">{num}</span>
        {live ? (
          <span
            data-testid={`live-badge-${product.slug}`}
            className="flex items-center gap-2 border border-[#FF5500]/40 bg-[#FF5500]/10 px-2.5 py-1"
          >
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#FF5500]" />
            <span className="font-mono-ind text-[10px] font-semibold uppercase tracking-[0.2em] text-[#FF5500]">
              Available now
            </span>
          </span>
        ) : (
          <span
            data-testid={`soon-badge-${product.slug}`}
            className="border border-white/15 bg-white/5 px-2.5 py-1"
          >
            <span className="font-mono-ind text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-400">
              Coming soon
            </span>
          </span>
        )}
      </div>

      <h3 className="font-display mt-6 text-2xl font-bold uppercase leading-tight tracking-tight text-slate-100 sm:text-3xl">
        {product.short_name}
      </h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{product.tagline}</p>

      <div className="mt-7 flex items-center justify-between border-t border-white/10 pt-5">
        {live ? (
          <span data-testid={`price-${product.slug}`} className="font-display text-2xl font-extrabold text-[#FF5500]">
            {fmtPrice(product.price)}
          </span>
        ) : (
          <span className="font-mono-ind text-xs uppercase tracking-[0.2em] text-slate-500">
            Pricing TBA
          </span>
        )}
        {live ? (
          <Link
            data-testid={`view-product-${product.slug}`}
            to={`/product/${product.slug}`}
            className="flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wider text-slate-200 transition-colors hover:text-[#FF5500]"
          >
            View pack <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        ) : (
          <NotifyModal
            slug={product.slug}
            productName={product.short_name}
            trigger={
              <button
                data-testid={`notify-${product.slug}`}
                className="flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wider text-slate-400 transition-colors hover:text-[#FF5500]"
              >
                Notify me <Bell className="h-4 w-4" />
              </button>
            }
          />
        )}
      </div>
    </div>
  );
}
